// Seasonal-forecast probability chart: per-admin-1 stacked bars of the four
// tercile categories for the forecast season. Takes the `forecast_summary`
// object from `data=longrange_forecast`.

import ReactECharts from "echarts-for-react";

import { FORECAST_CATEGORIES } from "./forecast";

const KEYS = FORECAST_CATEGORIES.map((c) => c.key);

const ForecastChart = ({ data, compact = false }) => {
  const overview = Array.isArray(data?.overview) ? data.overview : [];
  const rows = overview.slice(0, compact ? 6 : 10);

  if (rows.length === 0) {
    // Fall back to a single national bar if only the aggregate is present.
    const pct = data?.percentage_area;
    if (!pct) return null;
    rows.push({ admin_one_name: "National", ...pct });
  }

  const option = {
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    legend: {
      data: KEYS,
      bottom: 0,
      ...(compact
        ? { type: "scroll", textStyle: { fontSize: 10 }, itemWidth: 12, itemHeight: 10, itemGap: 6 }
        : {}),
    },
    grid: { left: "3%", right: "4%", bottom: compact ? "20%" : "12%", top: 12, containLabel: true },
    xAxis: {
      type: "category",
      data: rows.map((r) => r.admin_one_name),
      axisLabel: { interval: 0, rotate: rows.length > 4 ? 35 : 0, fontSize: 10 },
    },
    yAxis: { type: "value", max: 100, name: compact ? "" : "% area" },
    series: FORECAST_CATEGORIES.map((cat) => ({
      name: cat.key,
      type: "bar",
      stack: "total",
      barWidth: compact ? 14 : 24,
      itemStyle: { color: cat.color },
      data: rows.map((r) => r[cat.key] ?? 0),
    })),
  };

  return <ReactECharts option={option} style={{ height: compact ? "230px" : "300px", width: "100%" }} />;
};

export default ForecastChart;
